import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { LoyaltyCurrency } from '@rd/types';
import { TransferConnectV2WrapperComponentDirective } from '../../transfer-connect-v2-wrapper.component';

@Component({
  selector: 'rd-tcv2-programs-banner-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TcV2ProgramsBannerWrapperComponent extends TransferConnectV2WrapperComponentDirective {
  @HostBinding('class.rd-tcv2-programs-banner-wrapper') componentClass = true;

  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  componentName = 'tcv2-programs-banner';
}
